import EventListCard from '@/components/EventListCard'
import React from 'react'

export default function OrganizationModels() {
    return <EventListCard />
}
